import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
})
export class ConfirmModalComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() btnConfirmText: string;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
  ) {
    this.btnConfirmText =
      this.btnConfirmText || this.translate.instant('Confirm');
  }
}
